(function () {
  function initMessageBars() {
    var sliders = document.querySelectorAll('.msgbar-slider');

    sliders.forEach(function (slider) {
      var viewport = slider.querySelector('.msgbar-viewport');
      if (!viewport) return;

      var messages = Array.prototype.slice.call(viewport.querySelectorAll('.msgbar-item'));
      if (messages.length === 0) return;

      // Mark this slider as JS-controlled immediately, disabling the
      // CSS-only :first-child fallback so it can't conflict with cycling.
      slider.classList.add('js-ready');

      var displaySeconds = parseFloat(slider.getAttribute('data-display-seconds')) || 5;
      var speedAttr = slider.getAttribute('data-transition-speed') || 'medium';
      var transitionDuration = speedAttr === 'slow' ? 0.9 : (speedAttr === 'fast' ? 0.35 : 0.6);
      slider.style.setProperty('--msg-transition-duration', transitionDuration + 's');

      function setViewportHeight() {
        var maxHeight = 0;
        messages.forEach(function (m) {
          if (m.offsetHeight > maxHeight) maxHeight = m.offsetHeight;
        });
        if (maxHeight > 0) viewport.style.height = maxHeight + 'px';
      }

      var currentIndex = 0;
      messages[currentIndex].classList.add('is-active');
      setViewportHeight();
      window.addEventListener('resize', setViewportHeight);

      if (messages.length === 1) {
        return;
      }

      function cycle() {
        var current = messages[currentIndex];
        var nextIndex = (currentIndex + 1) % messages.length;
        var next = messages[nextIndex];

        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        next.classList.add('is-active');

        window.setTimeout(function () {
          current.classList.add('is-resetting');
          current.classList.remove('is-leaving');
          void current.offsetWidth;
          current.classList.remove('is-resetting');
        }, transitionDuration * 1000 + 20);

        currentIndex = nextIndex;
      }

      setInterval(cycle, displaySeconds * 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMessageBars);
  } else {
    initMessageBars();
  }
})();
